export default __webpack_public_path__ + "static/media/bgOne.2228d036.jpg";